import type {ComponentPublicInstance} from 'vue'

export function toHtmlElement(element: Element | ComponentPublicInstance | null): HTMLElement | null {
  if(element instanceof HTMLElement) {
    return element
  }
  if(element && '$el' in element && element.$el instanceof HTMLElement) {
    return element.$el
  }
  return null
}
